import { all, takeEvery, put } from "redux-saga/effects";
import actions from "./actions";
import fake from "./fake";
import fakeinitdata from "./config";

export function* changedCard() {
  yield takeEvery(actions.CHANGE_CARDS, function* () { });
}
export function* initData() {
  let fakeData = fakeinitdata;

  if (fakeinitdata.productQuantity.length === 0) {
    fakeData = fake;
  }

  // Determine initial mallType (shopType) based on pathname or localStorage
  let initialMallType = 3; // Default
  try {
    const pathname = window?.location?.pathname;

    if (pathname.includes("shopM")) {
      initialMallType = 2;
    } else if (pathname.includes("upgradeMall")) {
      initialMallType = 4;
    } else {
      const saved = JSON.parse(localStorage.getItem("mallType"));
      if (saved) {
        initialMallType = saved;
      }
    }

    localStorage.setItem("mallType", JSON.stringify(initialMallType));
  } catch (err) {
    console.warn("Failed to resolve initial mallType:", err);
  }

  yield put({
    type: actions.INIT_DATA,
    payload: {
      ...fakeData,
      mallType: initialMallType,
    },
  });
}
export function* updateData({ products, productQuantity }) {
  localStorage.setItem("cartProductQuantity", JSON.stringify(productQuantity));
  localStorage.setItem("cartProducts", JSON.stringify(products));
  yield put({
    type: actions.UPDATE_DATA,
    products,
    productQuantity,
  });
}
export function* updateDataTemp({ tempProducts, tempProductQuantity }) {
  yield put({
    type: actions.UPDATE_DATA_TEMP,
    tempProducts,
    tempProductQuantity,
  });
}

export function* clearCart() {
  localStorage.removeItem("cartProductQuantity");
  localStorage.removeItem("cartProducts");
  const products = [];
  const productQuantity = [];
  yield put({
    type: actions.CLEAR_CART,
    products,
    productQuantity,
  });
}

export function* changeMallType({ mallType }) {
  localStorage.setItem("mallType", JSON.stringify(mallType));

  yield put({
    type: actions.CHANGE_MALL_TYPE,
    mallType,
  });
}

export default function* () {
  yield all([
    takeEvery(actions.INIT_DATA_SAGA, initData),
    takeEvery(actions.UPDATE_DATA_SAGA, updateData),
    takeEvery(actions.UPDATE_DATA_TEMP_SAGA, updateDataTemp),
    takeEvery(actions.CLEAR_CART_SAGA, clearCart),
    takeEvery(actions.CHANGE_MALL_TYPE_SAGA, changeMallType),
  ]);
}
